import { PaginationResponseParams } from '@Pages/RetroSynthesis/constants';
import isUndefined from 'lodash/isUndefined';

const mapPredictedResponse = (response) => {
  const { content, totalPages, totalElements, number, size, jobId } = response;

  return {
    jobId,
    content: isUndefined(content) ? [] : content,
    [PaginationResponseParams.PAGE_NUMBER]: number || 0,
    [PaginationResponseParams.SIZE]: size || 10,
    [PaginationResponseParams.TOTAL_ELEMENTS]: totalElements || 0,
    [PaginationResponseParams.TOTAL_PAGES]: totalPages || 5,
  };
};

export default mapPredictedResponse;
